/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import DriverModel from '@/api/driver/driver.model';
import VehicleModel from '@/api/vehicle/vehicle.model';

/**
 * Component.
 */
@Component({
  name: 'driver-information-component'
})
export default class extends Vue {
  /**
   * Property `driver`.
   */
  @Prop({ type: Object })
  driver: DriverModel;

  /**
   * Property `vehicle`.
   */
  @Prop({ type: Object })
  vehicle: VehicleModel;

  /**
   * Getter empty image.
   */
  get emptyImage() {
    return 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
  }

  /**
   * Getter driver photo.
   */
  get driverPhoto() {
    const { photoLink = null } = this.driver || {};

    return photoLink;
  }

  /**
   * Getter vehicle photo.
   */
  get vehiclePhoto() {
    const { photoLink = null } = this.vehicle || {};

    return photoLink;
  }
}
